import React, { PureComponent } from 'react'
import { bool, func } from 'prop-types'
import { createComponent } from '@ycos/fela'
import NavigationButton from './NavigationButton'

class NavigationButtons extends PureComponent {
  render() {
    const { handlePreviousClick, disablePrevious, handleNextClick, disableNext } = this.props
    return (
      <Container>
        <NavigationButton dataAutomation="content-carousel-left" onClick={handlePreviousClick} disabled={disablePrevious} direction={'left'} />
        <NavigationButton dataAutomation="content-carousel-right" onClick={handleNextClick} disabled={disableNext} direction={'right'} />
      </Container>
    )
  }
}

NavigationButtons.propTypes = {
  handlePreviousClick: func,
  disablePrevious: bool,
  handleNextClick: func,
  disableNext: bool
}

const Container = createComponent('NavigationButtonsContainer', () => ({
  position: 'absolute',
  right: '0',
  zIndex: 1
}))

export default NavigationButtons
